import { Button } from 'flowbite-react';
import { t } from 'i18next';
import React from 'react';
import { HttpStatus } from '../../../common/enums/HttpStatus';

interface ErrorComponentProps {
  /** The RTK Query error, used to pick the message by HTTP status. */
  error?: unknown;
  /** Shows a Try again button that calls it (usually the query's refetch). */
  onRetry?: () => void;
  /** A fixed message, for callers that already know what to say. */
  errorMessage?: string;
}

/** The HTTP status of an RTK Query error, or undefined for a network or unknown error. */
export const getErrorStatus = (error: unknown): number | undefined => {
  if (!error || typeof error !== 'object') return undefined;
  const { status, originalStatus } = error as {
    status?: unknown;
    originalStatus?: unknown;
  };
  if (typeof status === 'number') return status;
  if (typeof originalStatus === 'number') return originalStatus;
  return undefined;
};

export const ErrorComponent: React.FC<ErrorComponentProps> = ({
  error,
  onRetry,
  errorMessage,
}) => {
  const forbidden = getErrorStatus(error) === HttpStatus.Forbidden;
  const message =
    errorMessage ||
    (forbidden ? t('common.error.forbidden') : t('common.error.loadPage'));

  return (
    <div
      role="alert"
      className="flex flex-col items-center justify-center gap-4 text-center text-2xl text-gray-600 dark:text-gray-300"
    >
      <p>{message}</p>
      {onRetry && !forbidden && (
        <Button color="gray" onClick={onRetry}>
          {t('common.error.tryAgain')}
        </Button>
      )}
    </div>
  );
};
